import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function AboutPaula() {
  return <section className="bg-cream-light py-14 md:py-20" data-id="element-20" data-mp="7nw2sc5bt2cl">
      <div className="max-w-5xl mx-auto px-6" data-id="element-21" data-mp="7p78ihic0k6c">
        <div className="flex flex-col md:flex-row gap-10 md:gap-16 items-center" data-id="element-22" data-mp="lnosc4549ciz">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full md:w-1/2 relative" data-id="element-23" data-mp="goc4bg2idzet">
            <div className="absolute -inset-4 border border-gold-main/30 rounded-sm transform rotate-3" data-id="element-24" data-mp="zejznbzyvlkg"></div>
            <img src="https://cdn.magicpatterns.com/uploads/29NxcQqDS3LEvn4F44HhTt/IMG_9091_1.webp" alt="Paula Giraldo oficiando una ceremonia" className="relative z-10 w-full h-auto object-cover rounded-sm shadow-lg aspect-[4/5]" loading="lazy" data-id="element-25" data-mp="1ebktpm5mrsm3" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full md:w-1/2 space-y-5" data-id="element-26" data-mp="1mw158an14k9b">
            <h2 className="text-3xl md:text-4xl font-playfair font-bold text-brown-dark" data-id="element-27" data-mp="25s9fjsuwflbh">
              Hola, soy Paula Giraldo,
            </h2>

            <div className="space-y-4 font-lora text-lg text-brown-light leading-relaxed" data-id="element-28" data-mp="2emxfd3hpgasw">
              <p data-id="element-29" data-mp="2jlqt8x0wm3tl">
                Y seré la responsable de guiarte en todo este eBook, he cuidado
                cada detalle para que tengas una experiencia teórica y práctica
                como ninguna otra, para poder hacer tus espacios de manera
                personal pero también poder guiarlos de manera profesional y
                consciente.
              </p>
              <p data-id="element-30" data-mp="jhemm6ib99wy">
                Me puedes encontrar en redes como{' '}
                <span className="font-semibold text-gold-dark" data-id="element-31" data-mp="y9ggn9xp98p2">
                  @ceremoniasimbólicas.paula
                </span>{' '}
                por si quieres saber un poco más de mí.
              </p>
              <p className="pt-2 italic text-brown-dark border-l-2 border-gold-main pl-4" data-id="element-32" data-mp="17awrtjwc9euc">
                Durante años he acompañado a cientos de personas en momentos
                importantes de sus vidas a través de espacios sagrados. Mi
                trabajo se basa en integrar espiritualidad consciente, trabajo
                sistémico, rituales simbólicos y acompañamiento emocional.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}